export interface LatLngLiteral {
  lat: number;
  lng: number;
}

interface Coordinate {
  x: number;
  y: number;
}

// reference: https://developers.google.com/maps/documentation/javascript/examples/map-coordinates
// The mapping between latitude, longitude and pixels is defined by the web
// mercator projection.
const project = (latLng: LatLngLiteral): Coordinate => {
  const TILE_SIZE: number = 256;
  let siny = Math.sin((latLng.lat * Math.PI) / 180);

  // Truncating to 0.9999 effectively limits latitude to 89.189. This is
  // about a third of a tile past the edge of the world tile.
  siny = Math.min(Math.max(siny, -0.9999), 0.9999);
  return {
    x: TILE_SIZE * (0.5 + latLng.lng / 360),
    y: TILE_SIZE * (0.5 - Math.log((1 + siny) / (1 - siny)) / (4 * Math.PI)),
  };
};

//reference: https://stackoverflow.com/questions/20916953/get-distance-between-two-points-in-canvas
export const getPixelDistance = (
  cluster: LatLngLiteral,
  point: LatLngLiteral,
  zoom: number
) => {
  const clusterPixelPoint = project(cluster);
  const pointPixelPoint = project(point);

  const scale = Math.pow(2, zoom);
  const dx = (clusterPixelPoint.x - pointPixelPoint.x) * scale;
  const dy = (clusterPixelPoint.y - pointPixelPoint.y) * scale;

  return Math.sqrt(dx * dx + dy * dy);
};
